<template>
  <div class="goodsdetail">
    <!--头部导航-->
    <top-nav ref="TopNav"></top-nav>
    <!--<van-nav-bar  :title="datas != ''?goods.name:''" fixed left-arrow @click-left="goBack" @click-right="onClickRight">-->
      <!--<van-icon slot="right" class="iconfont icon-zhankai"></van-icon>-->
    <!--</van-nav-bar>-->
    <!--<div class="topNav">-->
      <!--<i @click="back()" style="margin-left: 15px" class="iconfont zuocehua icon-zuocehua"></i>-->
      <!--<i @click="onClickRight" style="position: absolute;right:22px;" class="iconfont iconfontgengduo icon-iconfontgengduo"></i>-->
    <!--</div>-->
    <div style="padding-top: 0" class="van-content" v-if="datas!= ''">
      <!--banner-->
      <van-swipe :autoplay="3000">
        <van-swipe-item v-for="items in banner" :key="items.id">
          <img :src="items"  onerror="src='/static/errorimg1.png'"/>
        </van-swipe-item>
      </van-swipe>
      <div class="countbox" v-if="datas.goods.end_time-datas.goods.time > 1000">
      	<span class="text-left">限时兑</span>
        <span class="float-right clear:after"><span>剩</span><span>{{ parseInt((datas.goods.end_time-datas.goods.time)/(24*60*60)) }}</span>天<span>{{ parseInt((datas.goods.end_time-datas.goods.time)/(60*60)%24) }}</span>时<span>{{ parseInt((datas.goods.end_time-datas.goods.time)/(60)%60) }}</span>分<span>{{ parseInt((datas.goods.end_time-datas.goods.time)/(1)%60) }}</span>秒</span>
      </div>
      <!--商品信息-->
      <van-cell-group>
        <van-cell>
          <template slot="title">
            <span class="van-cell-text"><span plain class="theme-col radius theme-bg jd" v-if="goods.dummy == 3">京东</span>{{ goods.name }}</span>
          </template>
          <!--<van-icon slot="right-icon" name="" class="iconfont icon-shoucang" style="font-size: 2.5rem;margin-top: 5px" :class="collect_status == 1?'theme-col icon-shoucang-tianchong':''"  @click="addCollect"/>-->
        </van-cell>
        <van-cell style="padding-top: 0">
          <div>
            <span class="theme-col product-price">{{ goods.points_price }}</span>
            <span v-if="goods.old_points_price" class="ft12 product-price product-oldprice">{{ goods.old_points_price }} {{ goods.currency }}</span>
          </div>
          <div slot="right-icon" class="van-cell__right-icon">已兑{{ goods.sales_nums }}件</div>
        </van-cell>
      </van-cell-group>
      <van-cell-group>
        <!--步进器-->
        <van-cell v-if="goods.dummy == 0 || goods.dummy == 3 " style="line-height: 30px">兑换数量<van-stepper :disabled="numchange"  v-model="nums" style="display: inline-block;vertical-align: middle;float: right"/></van-cell>
        <!--地址选择-->
        <van-cell @click="cityPickershow" v-if="goods.dummy == 3" style="border-top: 1px solid #f2f2f2">配送至：{{ sitedDatasName }} </van-cell>
        <!--品牌-->
        <div class="van-cell van-cell--clickable van-hairline" style="border-top: 1px solid #f2f2f2" v-if="datas.goods.brand_id != 0&&datas.goods.brand_id != null&&datas.goods.brand_id != ''">
          <div class="van-cell__title">
            <router-link tag="div" class="brandbox" :to="{path:'/brandgoods',query:{brand_id:datas.goods.brand_id}}">
              <img class="brandimg" onerror="src='/static/errorimg1.png'" :src="datas.goods.img">
              <div class="brand-referral">
                <p class="brand-title">{{ datas.goods.brand_name }}</p>
                <div class="ellipseal brand-detail">{{ datas.goods.brief }}</div>
              </div>
            </router-link>
          </div>
          <i class="van-icon van-icon-arrow van-cell__right-icon" style="line-height: 80px"></i>
        </div>
        <!--内容-->
        <van-popup></van-popup>
      </van-cell-group>
      <!--商品详情-->
      <!--<van-tabs id="lvse" :class="{tabtop:vanTabs}">
        <van-tab title="图文详情">
          <div class="van-cell">图文详情</div>
          <div v-html="goods.product_desc" class="clear goodstab"></div>
        </van-tab>
        <van-tab title="兑换须知">
          <div v-html="datas.purchase_notic" class="clear goodstab"></div>
        </van-tab>
      </van-tabs>-->
      <van-cell-group>
        <van-cell>图文详情</van-cell>
        <van-cell>
          <div v-if="goods.product_desc!=''"   v-html="goods.product_desc" class="clear goodstab"></div>
          <div style="text-align: center" v-if="goods.product_desc==''" class="clear goodstab"><img style="width: 8rem" src="/static/images/nodataimg.png" alt=""><p>暂无详情~</p> </div>
        </van-cell>
      </van-cell-group>
      <van-cell-group>
        <van-cell>兑换须知</van-cell>
        <van-cell>
          <div style="padding: 15px" v-html="datas.purchase_notic" class="clear goodstab"></div>
          <div style="text-align: center" v-if="datas.purchase_notic==''" class="clear goodstab"><img style="width: 8rem" src="/static/images/nodataimg.png" alt=""><p>暂无须知~</p> </div>
        </van-cell>
      </van-cell-group>
    </div>
    <!--立即购买弹窗-->
    <van-sku v-if="goods.dummy == 0 || goods.dummy == 3" v-model="showCustomAction" :sku="sku">
      <!-- 头部信息 -->
      <template slot="sku-header" slot-scope="props">
        <div class="van-hairline--bottom van-sku-header">
          <div class="van-sku-header__img-wrap"><img v-lazy="goods.product_img"></div>
          <div class="van-sku-header__goods-info">
            <div class="van-sku__goods-name van-ellipsis"></div>
            <div class="van-sku__goods-price">
              <p class="ellipseal"><span plain class="theme-col theme-bg jd radius" v-if="goods.dummy == 3">京东</span>{{ goods.name }}</p>
              <span class="van-sku__price-symbol"></span><span class="van-sku__price-num theme-col">{{ goods.points_price }}</span></div>
            <i class="van-sku__close-icon van-icon van-icon-close" @click="showCustom"></i>
          </div>
        </div>
      </template>
      <!-- 商品sku展示区 -->
      <template slot="sku-group" slot-scope="props">
        <div></div>
      </template>
      <!-- 商品数量选择 -->
      <template slot="sku-stepper" slot-scope="props">
        <div class="van-sku-stepper-stock">
          <div class="van-sku-stepper-container">
            <div class="van-sku__stepper-title">数量：</div>
            <div class="van-sku__stepper van-stepper">
              <van-stepper :disabled="numchange" v-model="nums"/>
            </div>
          </div>
          <!--<div class="van-sku__stock">剩余227件</div>-->
          <!--<div class="van-sku__quota">每人限购15件</div>-->
        </div>
      </template>
      <!-- 留言 -->
      <template slot="sku-messages" slot-scope="props">
        <div></div>
      </template>
      <!-- 底部按钮 -->
      <template slot="sku-actions" slot-scope="props">
        <div class="van-sku-actions">
          <!--<van-button bottom-action>积分兑换</van-button>-->
          <!-- 直接触发 sku 内部事件，通过内部事件执行 onBuyClicked 回调 -->
          <van-button type="primary theme-bg" bottom-action @click="onBuyClicked">确定</van-button>
        </div>
      </template>
    </van-sku>
    <!--地址选择弹框-->
    <City-Picker ref="CityPicker" v-on:listenSitedata="geSitedatas" v-if="goods.dummy == 3"></City-Picker>
    <!--底部-->
    <van-goods-action style="z-index: 100;" v-if="datas != ''">
      <a  class="van-hairline van-goods-action-mini-btn collect" @click="addCollect" :class="collect_status == 1?'theme-col':''">
        <!--<i class="van-icon iconfont icon-shoucang" :class="collect_status == 1?'theme-col icon-shoucang-tianchong':''" style="font-size: 20px;">-->
          <span>加入收藏</span>
        <!--</i>-->
      </a>
      <!--<van-goods-action-mini-btn icon="cart" text="兑换袋" to="/user/cart"/>-->
      <!--<van-goods-action-big-btn text="加入兑换袋" @click="addCart"  v-if="goods.dummy == 0 || goods.dummy == 3"/>-->
      <van-goods-action-big-btn style="width: 50%">
        <van-button @click="showCustom" :disabled="disabled" :class="!disabled?'theme-bg theme-bd':''" style="width: 100%;height: 100%;border-radius: 0;border: none;">立即兑换</van-button>
      </van-goods-action-big-btn>
    </van-goods-action>

  </div>
</template>

<script>
  import CityPicker from '@/pages/user/mysite/cityPicker'
  import TopNav from '@/components/topnav'
  export default {
    name: "detail",
    components: {
      CityPicker,
      TopNav
    },
    props:['configData'],
    data () {
      return {
        vanTabs:false,
        disabled:false,
        sitedDatas:'',
        sitedDatasName:'',
        collect_status:false,
        datas:'',
        goods:'',
        banner:'',
        type1:'',
        id:this.$route.query.id,  //商品id
        nums:1, //购买数量
        showCustomAction:false,  //购买弹窗开启状态
        sku: {
          tree: [],
          list: [],
        },
        province:'',
        city:'',
        town:'',
        county:'',
        numchange:false,//限时抢购不能选择数量

//        col:configData.theme_color,
      }
    },
    methods: {
      back:function () {
        history.go(-1);
      },
      cityPickershow:function () {
        this.$refs.CityPicker.cityPickershow()
      },
      geSitedatas:function (datas) {
        this.sitedDatasName = ''
        this.sitedDatas = datas
        if(datas[0].id != undefined){
          this.sitedDatasName += datas[0].name
          this.province = datas[0].id
        }
        if(datas[1].id != undefined){
          this.sitedDatasName += "-"+datas[1].name
          this.city = datas[1].id
        }
        if(datas[2].id != undefined){
          this.sitedDatasName += "-"+datas[2].name
          this.town = datas[2].id
        }
        if(datas[3].id != undefined){
          this.sitedDatasName += "-"+datas[3].name
          this.county = datas[3].id
        }
      },
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      },
      getDatas:function () {
        var isUser=localStorage.getItem("BLHuser")
        this.$api.get('WebApi/Product/Product/preview', {token:isUser,id:this.id}, res => {
          if( res.data.errCode == '0303' ){
            this.$dialog.alert({
              title:'提示',
              message: '该商品已下架'
            }).then(() => {
              this.goBack()
            })
          }else if(res.data.errCode == '0000'){
            this.datas = res.data.data
            this.banner = res.data.data.goods.banner_img
            this.goods = res.data.data.goods
            this.type1=res.data.data.goods.dummy
            res.data.data.collect_status == 0?this.collect_status=false:this.collect_status=true
            if(res.data.data.goods.is_rob==1){
              this.numchange=true//限时抢购不能选择数量
            }else{
              this.numchange=false
            }
            this.countDown()

          }
        })
      },
      countDown: function () {
        var _this = this;
        if(_this.datas.goods.time != undefined){
          setInterval(function () {
            if(_this.datas.goods.time < _this.datas.goods.end_time){
              var counttime = _this.datas.goods.time + 1
              _this.datas.goods.time = counttime
            }else{
              _this.datas.goods.time = "时间到"
            }
          },1000)
        }
      },
      // 加入兑换袋
      addCart: function () {
        var isUser=localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Member/Cart/addCart', {token:isUser,product_id:this.id,nums:this.nums,province:this.province,city:this.city,town:this.town,county:this.county}, res => {
          if(res.data.errCode == '0000'){
            this.$toast(res.data.desc)
          }else if (res.data.errCode == '1002') {
            this.$dialog.confirm({
              title:'提示',
              message: '您还未登录是否去登录？'
            }).then(() => {
              this.$router.push({path:'/login'})
            }).catch(() => {
              // on cancel
            });
          }else{
            this.$toast(res.data.desc)
          }
        })
      },
      // 加入收藏
      addCollect: function () {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Member/Collection/collect', {token:isUser,product_id:this.id}, res => {
          if(res.data.errCode == '0000'){
            this.$toast(res.data.desc)
            this.collect_status = !this.collect_status
          }else{
            this.$dialog.confirm({
              title:'提示',
              message: '您还未登录是否去登录？'
            }).then(() => {
              this.$router.push({path:'/login'})
            }).catch(() => {
              // on cancel
            });
          }
        })
      },
      // 底部立即购买
      showCustom: function () {
        //实物走这
        if(this.goods.dummy == 0 || this.goods.dummy == 3){
          this.showCustomAction = !this.showCustomAction
        }
        //虚拟走这
        else{
          this.onBuyClicked()
        }
      },
      //购买商品
      onBuyClicked: function () {
        var isUser=localStorage.getItem("BLHuser")
        var goodsId = {}
        goodsId[this.id] = this.nums.toString()
        var strOnDatasId = JSON.stringify(goodsId)/*.replace(/\"/g, "")*/
        if(isUser != null && isUser != '' && isUser != undefined){
          this.$api.post('WebApi/JifenOrder/CreatOrder/index', {token:isUser,goods:strOnDatasId,province:this.province,city:this.city,town:this.town,county:this.county}, res => {
            if(res.data.errCode == '0000'){
              this.$router.push({path:'/affirmOrder',query:{type:this.type1}})
            }else if(res.data.errCode == '1002'){
              this.$dialog.confirm({
                title:'提示',
                message: '您还未登录是否去登录？'
              }).then(() => {
                this.$router.push({path:'/login'})
              }).catch(() => {
                // on cancel
              });
            }else{
              this.$toast(res.data.desc)
            }
          })
        }else{
          this.$dialog.confirm({
            title:'提示',
            message: '您还未登录是否去登录？'
          }).then(() => {
            this.$router.push({path:'/login'})
          }).catch(() => {
            // on cancel
          });
        }

      },
      menu: function () {
        var _this = this
        window.addEventListener('scroll',function () {
          if(_this.$route.name == 'Goods'){
            var toop = document.getElementById('lvse').offsetTop - 44
            if(document.documentElement.scrollTop >= toop){
              _this.vanTabs = true
            }else if(document.documentElement.scrollTop < toop){
              _this.vanTabs = false
            }
          }
        })
      },
    },
    mounted () {
      this.getDatas()
    },
  }
</script>
<style lang="less">
  .goodsdetail{
    .van-sku-container{
      overflow: inherit;
    }
    .brandbox{
      width: 100%;
      display: inline-block;
      position: relative;
      .brandimg{
        width: 80px;
        height: 80px;
      }
      .brand-referral{
        position: absolute;
        width: 100%;
        top: 0;
        padding-left: 90px;
        box-sizing: border-box;
        .brand-title{
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 5px;
        }
        .brand-detail{

        }
      }
    }
    .product-price{
      font-size: 1.8rem;
    }
    .product-oldprice{
      text-decoration: line-through;
      color: #999;
    }
    .van-stepper__input{
      vertical-align: top;
    }
    .van-hairline--top-bottom::after{
      border-width:0
    }
    .van-cell:not(:last-child)::after{
      border-bottom-width:0
    }
    .van-tabs{
      z-index: 0;
      background: #fff;
    }
    .van-cell-group,.van-cell{
      background-color: #fff;
    }
    .van-button--bottom-action{
      line-height: 48px;
    }
    .tabtop .van-tabs__wrap--content-top{
      position: fixed;
      top: 44px;
    }
    .goodstab img{
      width: 100%;
      height: auto!important;
    }
    .goodstab table,.goodstab tr{
      width: 100%!important;
      height: auto!important;
    }
    .goodstab div{
      width: 100%!important;
    }
    .goodstab div,.goodstab p{zoom:1;}
    .goodstab div:before,
    .goodstab p:before,
    .goodstab div:after,
    .goodstab p:after{display:table;content:"";line-height:0;}
    .goodstab div:after,
    .goodstab p:after{clear:both;}
    .countbox{
      background-color: #ff8700;
      color: #fff;
      padding: 10px 15px;
      font-size: 1.6rem;
      overflow: hidden;
    }
    .radius {
      padding: 0 5px 1px!important;
      -webkit-border-radius:10px 0;
      -moz-border-radius:10px 0;
      border-radius:10px 0 ;
    }
    .totop{
      width: 38px;
      height: 38px;
      border-radius: 50%;
      position: fixed;
      bottom:56px;
      right: 10px;
      background: #ddd;
      text-align: center;
    }
    .totop i{
      font-size: 22px;
      line-height: 38px;
      color: #fff!important;
    }
    .van-button--bottom-action.van-button--primary {
      /*background-color: #ff4a59!important;*/
    }
    .collect{
      i{
        vertical-align: middle;
      }
      span{
        margin-left: 8px;
        font-size: 14px;
        vertical-align: middle;
      }
      width: 50%;font-size: 14px;color: #333;
      text-align: center;

    }
    .topNav{
      height: 45px;
      background: transparent;
      position: fixed;
      top:0;
      left: 0;
      z-index: 100;
      line-height: 50px;
      width: 100%;
      i{
        font-size: 25px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/goods/detail.vue